import { AxiosResponse } from 'axios';

export const isAxiosResponseOk = (response: AxiosResponse) =>
  response.status >= 200 && response.status < 400;

export const genericApiError = () => Promise.reject();
